import React, { useState, useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { ModelCard } from '../components/ModelCard';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { API } from '../lib/api';

export function FavoritesPage() {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      const res = await axios.get(`${API}/favorites`, { withCredentials: true });
      setFavorites(res.data);
    } catch (error) {
      console.error('Failed to load favorites:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />

      <main data-testid="favorites-page" className="mt-16 pt-12 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-12"
          >
            <div className="flex items-center space-x-3 mb-2">
              <Heart className="w-8 h-8 text-red-500 fill-current" />
              <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight">Meus Favoritos</h1>
            </div>
            <p className="text-zinc-400">Suas descobertas STL salvas</p>
          </motion.div>

          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="aspect-video bg-[#1A1A1A] rounded-lg animate-pulse" />
              ))}
            </div>
          ) : favorites.length === 0 ? (
            <div data-testid="empty-favorites" className="text-center py-20">
              <Heart className="w-20 h-20 text-zinc-700 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-white mb-2">Ainda sem favoritos</h2>
              <p className="text-zinc-400 mb-6">Comece a explorar e salve suas impressões favoritas</p>
              <a
                href="/"
                className="inline-block bg-[#0066FF] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#3385FF] transition-all"
              >
                Descobrir Impressões
              </a>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {favorites.map((model) => (
                <ModelCard key={model.id} model={model} isPremiumUser={user?.is_premium} />
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
